<template>
	<div class="mt-1 flex flex-row flex-wrap items-center gap-1.5">
		<TextChip
			v-if="user instanceof GVAUserPrivilegedDTO && user.admin"
			:title="$t('common.admin')"
			class="bg-amber-400 text-white"
		/>
		<TextChip
			v-if="user?.internalUser"
			title="Internal"
			class="bg-green-500 text-white"
		/>
		<TextChip
			v-if="user instanceof GVAUserPrivilegedDTO && !user?.active"
			title="Deactivated"
			class="bg-red-500 text-white"
		/>
		<TextChip
			v-if="user instanceof GVAUserPrivilegedDTO && user.unlisted"
			title="Unlisted"
			class="bg-gray-400 text-white"
		/>
		<RoleChip
			v-for="role in userRoles"
			:key="role.id"
			:name="role.name"
			:color="role.color"
		/>
	</div>
</template>

<script setup lang="ts">
	import { computed } from "vue";
	import {
		GVAUserDTO,
		GVAUserPrivilegedDTO,
	} from "seedgreen-shared/dtos/GVAUserDTO";
	import { useUserRoles } from "seedgreen-shared/queries/user-role";
	import RoleChip from "@/components/feature/user/role/RoleChip.vue";
	import TextChip from "@/components/ui/TextChip.vue";

	const props = defineProps<{
		user: GVAUserDTO | GVAUserPrivilegedDTO | undefined;
	}>();

	const { userRoles: allRoles } = useUserRoles();

	const userRoles = computed(() => {
		if (
			!props.user ||
			!Array.isArray(props.user.roleIds) ||
			!allRoles.value
		) {
			return [];
		}
		return allRoles.value.filter((role) =>
			(props.user?.roleIds ?? []).includes(role.id),
		);
	});
</script>
